module.exports = __webpack_public_path__ + "fonts/Barlow-Thin.b4fc803e.eot";